import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import { NOTICE_TYPE_ERROR, NOTICE_TYPE_SUCCESS } from "config"

const DEFAULT_STATE = {
  isOpen: false,
  message: "",
  type: NOTICE_TYPE_SUCCESS,
}

const noticeAdapter = createEntityAdapter()
export const initialState = noticeAdapter.getInitialState(DEFAULT_STATE)

export const noticeSlice = createSlice({
  name: "notice",
  initialState,
  reducers: {
    showNotice: (state, { payload }) => {
      state.isOpen = true
      state.message = payload.message
      state.type = NOTICE_TYPE_SUCCESS
    },
    showAlert: (state, { payload }) => {
      state.isOpen = true
      state.message = payload.message
      state.type = NOTICE_TYPE_ERROR
    },
    hide: (state) => {
      state.isOpen = false
    },
  },
})

export const selectIsOpen = (state: RootState) => state.features.notice.isOpen
export const selectMessage = (state: RootState) => state.features.notice.message
export const selectType = (state: RootState) => state.features.notice.type

export const { showNotice, showAlert, hide } = noticeSlice.actions
export default noticeSlice.reducer
